import { render } from "./AcessGroupBtn.vue?vue&type=template&id=9d23bff6"
import script from "./AcessGroupBtn.vue?vue&type=script&lang=js"
export * from "./AcessGroupBtn.vue?vue&type=script&lang=js"

import "./AcessGroupBtn.vue?vue&type=style&index=0&id=9d23bff6&lang=css"

import exportComponent from "C:\\wamp64\\www\\projetos\\mestre\\mestre-do-valor-sn-administrativo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__